import app from '@/rest/app'
export default {
  state: () => ({
    system: null,
    initialized: false
  }),
  getters: {
    systemSettings: (state) => state.system,
    appSettingsInitialized: (state) => state.initialized
  },
  mutations: {
    setSettings (state, payload) {
      state.system = payload
      state.initialized = true
    }
  },
  actions: {
    async initSettings ({ commit }) {
      const systemSettings = await app.systemSettings()
      if (systemSettings) {
        commit('setSettings', systemSettings)
      }
    },
    initialize ({ dispatch, rootGetters }) {
      if (!rootGetters.isAuthorized) {
        return
      }
      dispatch('initSettings')
      import.meta.env.DEV && console.log('initialized store – settings')
    }
  }
}
